import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { Select, MenuItem } from '@mui/material';

// import FolderModal from '../upload/FolderModal';
// import CreateMongoDB from '../mongodb/CreateMongoDB';
import moment from 'moment';
import LogComponent from '../LogComponent';
import MetaDataComponent from '../MetaDataComponent';

import {
    CardContent,
    Grid,
    InputAdornment,
    TableCell,
    TableHead,
    TableRow,
    TableSortLabel,
    TextField,
    Toolbar,
    Typography,
    List,
    ListItemButton,
    ListItemIcon,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Divider,
    Paper
} from '@mui/material';

import MainCard from 'ui-component/cards/MainCard';
import { visuallyHidden } from '@mui/utils';
import DeleteIcon from '@mui/icons-material/Delete';

import SearchIcon from '@mui/icons-material/Search';

import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
    deleteProjectDocuments,
    updateProjectDocuments,
    fetchProjectAirflowDags,
    insertProjectAirflowDags,
    getProjectAirflowDags,
    getProjectAirflowDagsNodes,
    getProjectAirflowDagsEdges,
    deleteProjectAirflowDags
} from 'store/slices/project';
import { openSnackbar } from 'store/slices/snackbar';

import StorageIcon from '@mui/icons-material/Storage';
import { GridRowModes, GridActionsCellItem, GridRowEditStopReasons } from '@mui/x-data-grid';

import { randomId } from '@mui/x-data-grid-generator';

import { removeAccents } from 'utils/customized-functions';
import { AIRFLOW_URL } from 'config/domains';

import DeleteAirflow from './DeleteAirflow';
// import DeleteMongoDBData from './DeleteMongoDBData';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
// import { FileManager } from "@cubone/react-file-manager";
// import "@cubone/react-file-manager/dist/style.css";
import ReactFlow, { MiniMap, Controls, Background, useNodesState, useEdgesState, addEdge } from 'reactflow';

import 'reactflow/dist/style.css';
import { nodeTypes } from './DagNodes';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';

import OutlinedInput from '@mui/material/OutlinedInput';

// import Scheduler from "material-ui-cron"; // Commented out - not compatible with MUI v7
import Cron from 'react-js-cron';
import 'react-js-cron/dist/styles.css';
import './node.css';
// import MuiCron from "./Mui";
// import Slide from '@mui/material/Slide';

// const Transition = React.forwardRef(function Transition(props, ref) {
//     return <Slide direction="up" ref={ref} {...props} />;
//   });

const initialNodes = [
    { id: '1', type: 'start', data: { label: 'Start' }, position: { x: 100, y: 0 } }
];

const initialEdges = [
    // { id: 'e1-2', source: '1', target: '2', type: 'default' },
    // { id: 'e2-3', source: '2', target: '3', type: 'default' },
    // { id: 'e2-4', source: '2', target: '4', type: 'default' },
    // { id: 'e3-5', source: '3', target: '5', type: 'default' },
    // { id: 'e4-5', source: '4', target: '5', type: 'default' },
];

const options = [
    { label: 'Tất cả thời gian', value: 'all' },
    { label: '7 ngày trước', value: '7' },
    { label: '30 ngày trước', value: '30' },
    { label: '90 ngày trước', value: '90' }
];

const sortOptions = [
    { label: 'Xếp theo mới nhất', value: 'desc' },
    { label: 'Xếp theo cũ nhất', value: 'asc' }
];

/** Preset lịch chạy (Cron) – dùng khi tạo/chỉnh sửa DAG */
const CRON_PRESETS = [
    { value: '0 0 * * *', label: 'Hàng ngày (0:00)' },
    { value: '0 0 * * 0', label: 'Hàng tuần (Chủ nhật 0:00)' },
    { value: '0 0 * * 1', label: 'Hàng tuần (Thứ 2, 0:00)' },
    { value: '0 * * * *', label: 'Hàng giờ' },
    { value: '*/30 * * * *', label: '30 phút / lần' },
    { value: 'custom', label: 'Tùy chỉnh (Cron)' }
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};

// const names = [
//   'Oliver Hansen',
//   'Van Henry',
//   'April Tucker',
//   'Ralph Hubbard',
//   'Omar Alexander',
//   'Carlos Abbott',
//   'Miriam Wagner',
//   'Bradley Wilkerson',
//   'Virginia Andrews',
//   'Kelly Snyder',
// ];

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order, orderBy) =>
    order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    // { id: 'id', numeric: true, label: 'STT', align: 'center' },
    { id: 'file_name', numeric: false, label: 'Tài liệu', align: 'left' },
    { id: 'file_type', numeric: false, label: 'Loại tài liệu', align: 'center' },
    { id: 'file_size', numeric: true, label: 'Kích thước', align: 'center' },
    { id: 'labels', numeric: false, label: 'Nhãn', align: 'center' },
    { id: 'created_date', numeric: false, label: 'Thời gian cập nhật', align: 'center' }
];

const EnhancedTableHead = ({ onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, theme, selected }) => {
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox" sx={{ pl: 3 }}>
                    <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts'
                        }}
                    />
                </TableCell>
                {numSelected > 0 && (
                    <TableCell padding="none" colSpan={8}>
                        <EnhancedTableToolbar numSelected={selected.length} />
                    </TableCell>
                )}
                {numSelected <= 0 &&
                    headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{ minWidth: 150, padding: 0 }}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                                sx={{
                                    // fontSize: '0.1rem',
                                    fontWeight: 'bold'
                                }}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
            </TableRow>
        </TableHead>
    );
};

EnhancedTableHead.propTypes = {
    theme: PropTypes.object,
    selected: PropTypes.array,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

const EnhancedTableToolbar = ({ numSelected, selected }) => (
    <Toolbar
        sx={{
            p: 0,
            pl: 1,
            pr: 1,
            ...(numSelected > 0 && {
                color: (theme) => theme.palette.secondary.main
            })
        }}
    >
        {numSelected > 0 ? (
            <Typography color="inherit" variant="body1">
                Đã chọn {numSelected}
            </Typography>
        ) : (
            <Typography variant="h6" id="tableTitle">
                DAG đã chọn
            </Typography>
        )}
        <Box sx={{ flexGrow: 1 }} />
        {/* {numSelected > 0 && (
            <Tooltip title="Delete">
                <IconButton size="small" color="error" onClick={() => selected.forEach((name) => handleDelete(name))}>
                    <DeleteIcon fontSize="medium" />
                </IconButton>
            </Tooltip>
        )} */}
    </Toolbar>
);

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired
};

const apiHost = process.env.REACT_APP_API_URL;

const TableAirflow = ({ onClick, folderName, projectSubname, fetchProjectTables, dataMongoDBTable, isSetting }) => {
    const [metaDataOpen, setMetaDataOpen] = useState(false);
    const [logOpen, setLogOpen] = useState(false);
    const [originalRows, setOriginalRows] = useState(dataMongoDBTable);
    const [hideTableUploadFile, setHideTableUploadFile] = useState(false);
    const [open, setOpen] = useState(false);
    const [openFolder, setOpenFolder] = useState(false);
    const [sort, setSort] = useState('desc');
    const [timeRange, setTimeRange] = useState('all');
    const theme = useTheme();
    // const dispatch = () => { };
    const dispatch = useDispatch();
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('file_type');
    const [search, setSearch] = useState('');
    const [rows, setRows] = useState(dataMongoDBTable);
    const [fileName, setFileName] = useState('');
    const [uploadModalState, setUploadModalState] = React.useState('INACTIVE');
    const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
    const [openDeleteDataModal, setOpenDeleteDataModal] = React.useState(false);
    const [tableName, setTableName] = React.useState('');
    const [tableDesc, setTableDesc] = React.useState('');
    const [deleteId, setDeleteId] = React.useState('');

    const [dataAirflowDags, setDataAirflowDags] = React.useState('');

    // const [dataMongoDB, setDataMongoDB] = React.useState([])
    const [documentRows, setDocumentRows] = React.useState([]);
    // const [documentColumns, setDocumentColumns] = React.useState([])
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [isOpenAddTask, setOpenAddTask] = React.useState(false);
    const [isNameTableExists, setNameTableExists] = React.useState(false);

    const projectsState = useSelector((state) => state.project);

    const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
    const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
    const flowRef = useRef(null);

    const [taskName, setTaskName] = React.useState([]);
    const [task, setTask] = React.useState([]);
    const [dagsName, setDagsName] = React.useState([]);

    const handleBack = () => {
        setLogOpen(false);
        setMetaDataOpen(false);
    };

    const inputRef = useRef(null);
    const defaultValue = '30 5 * * 1,6';
    const [value, setValue] = useState(defaultValue);
    const [textValue, setTextValue] = useState('');
    const [error, onError] = useState('');
    const [cronExp, setCronExp] = useState('0 0 * * *');
    const [cronError, setCronError] = useState('');
    const [schedulePreset, setSchedulePreset] = useState('0 0 * * *'); // value hoặc 'custom'
    const [isAdmin, setIsAdmin] = useState(true); // set admin or non-admin to enable or disable high frequency scheduling (more than once a day)
    const [isDagNameExists, setDagNameExists] = useState(false);
    const [isDagUpdate, setDagUpdate] = useState(false);
    const [dagName, setDagName] = useState('');

    const handleChange = (event) => {
        const {
            target: { value }
        } = event;
        setTaskName(
            typeof value === 'string' ? value.split(',') : value
        );
        let nodes_ = [{ id: '1', type: 'start', data: { label: 'Start' }, position: { x: 150, y: 0 } }];
        value?.map((data, index) => {
            nodes_.push({
                id: String(index + 2),
                type: 'task',
                data: { label: data.replace('.py', '') },
                position: { x: 150, y: 80 * (index + 1) }
            });
        });
        nodes_.push({
            id: String(nodes_.length + 1),
            type: 'end',
            data: { label: 'End' },
            position: { x: 150, y: 80 * nodes_.length }
        });
        setNodes(nodes_);
    };
    const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), [setEdges]);

    useEffect(() => {
        if (!isOpenAddTask || nodes.length === 0) return;
        const t = setTimeout(() => {
            flowRef.current?.fitView?.({ padding: 0.2 });
        }, 100);
        return () => clearTimeout(t);
    }, [isOpenAddTask, nodes, edges]);

    useEffect(() => {
        const proj = folderName.replace('/', '');
        dispatch(fetchProjectAirflowDags(proj));
        dispatch(getProjectAirflowDags(proj));
    }, [folderName, dispatch]);

    useEffect(() => {
        setRows(projectsState.tables ?? []);
        setDocumentRows(projectsState.documents?.rows ?? []);
        const taskName = [];
        projectsState?.dags?.forEach((data) => {
            taskName.push(data['file_name']);
        });
        setTask(taskName);
        setDagsName(projectsState?.dags_name ?? []);

        // Chỉ áp dụng nodes/edges từ API khi đang chỉnh sửa DAG (đã chọn dagName), tránh ghi đè khi tạo DAG mới
        if (dagName && projectsState?.dags_nodes?.length > 0) {
            const nodeName = [];
            projectsState.dags_nodes.forEach((data) => {
                try {
                    const rawData = data?.data ?? data?.Data;
                    const parsedData =
                        typeof rawData === 'object' && rawData !== null
                            ? rawData
                            : (() => {
                                try {
                                    const s = String(rawData ?? '{}').replaceAll?.("'", '"') ?? '{}';
                                    return JSON.parse(s);
                                } catch {
                                    return {};
                                }
                            })();
                    const label = parsedData?.label || '';
                    const type = label === 'Start' ? 'start' : label === 'End' ? 'end' : 'task';
                    const rawPos = data?.position ?? data?.Position;
                    const position =
                        typeof rawPos === 'object' && rawPos !== null && typeof rawPos.x === 'number'
                            ? { x: rawPos.x, y: rawPos.y }
                            : (() => {
                                try {
                                    const s = String(rawPos ?? '{}').replaceAll?.("'", '"') ?? '{"x":0,"y":0}';
                                    return JSON.parse(s);
                                } catch {
                                    return { x: 0, y: 0 };
                                }
                            })();
                    nodeName.push({
                        id: data?.id,
                        type,
                        data: parsedData,
                        position
                    });
                } catch (e) {
                    // bỏ qua node lỗi
                }
            });
            setNodes(nodeName);

            const edgeName = (projectsState.dags_edges ?? []).map((data) => ({
                id: data?.id,
                source: data?.id_source,
                target: data?.id_target
            }));
            setEdges(edgeName);
        }
    }, [projectsState, dagName]);

    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id) => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => {
        dispatch(
            openSnackbar({
                open: true,
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                message: 'Chỉnh sửa thành công',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            })
        );
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
    };

    const handleDeleteClick = (id) => {
        setOpenDeleteDataModal(true);
        setDeleteId(id);
    };

    const handleDeleteData = (id) => {
        dispatch(deleteProjectDocuments(folderName, tableName, id));
        dispatch(
            openSnackbar({
                open: true,
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                message: 'Xóa thành công',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            })
        );
        setDocumentRows(documentRows?.filter((row) => row.id !== id));
        setOpenDeleteDataModal(false);
        setDeleteId('');
    };

    const handleCancelClick = (id) => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true }
        });

        const editedRow = documentRows?.find((row) => row.id === id);
        if (editedRow.isNew) {
            setDocumentRows(documentRows?.filter((row) => row.id !== id));
        }
    };

    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        dispatch(updateProjectDocuments(folderName, tableName, updatedRow));
        dispatch(
            openSnackbar({
                open: true,
                anchorOrigin: { vertical: 'top', horizontal: 'center' },
                message: 'Chỉnh sửa thành công',
                variant: 'alert',
                alert: {
                    color: 'success'
                }
            })
        );
        setDocumentRows(documentRows?.map((row) => (row.id === newRow.id ? updatedRow : row)));
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const filterDataByTimeRange = (range) => {
        console.log(range);
        const currentDate = moment();
        let targetDate;

        switch (range) {
            case '7':
                targetDate = currentDate.clone().subtract(7, 'days');
                break;
            case '30':
                targetDate = currentDate.clone().subtract(30, 'days');
                break;
            case '90':
                targetDate = currentDate.clone().subtract(90, 'days');
                break;
            case 'all':
                return originalRows;
            default:
                return [];
        }

        return originalRows.filter((row) => {
            const rowDate = moment(row.created_date, 'DD/MM/YYYY HH:mm:ss', true);
            return rowDate.isValid() && (rowDate.isAfter(targetDate) || rowDate.isSame(targetDate));
        });
    };

    const handleOpenMetaData = (row) => {
        setFileName(row.file_name);
        setMetaDataOpen(true);
        setHideTableUploadFile(!hideTableUploadFile);
    };

    const handleFilter = () => {
        if (timeRange === 'all') {
            setRows(originalRows);
        } else {
            const filteredRows = filterDataByTimeRange(timeRange);
            setRows(filteredRows);
        }
    };

    useEffect(() => {
        handleFilter();
    }, [timeRange, originalRows]);

    const handleTimeRangeChange = (e) => {
        setTimeRange(e.target.value);
        setRows(originalRows);
    };

    const handleDelete = () => {
        // console.log(selected)
        // dispatch(deleteProjectTables(folderName, tableName))
        dispatch(deleteProjectAirflowDags(folderName.replace('/', ''), dagName));
        setOpenDeleteModal(false);
        setOpenAddTask(false);
    };
    const handleSearch = (event) => {
        const newString = event?.target.value;
        setSearch(newString || '');

        if (newString) {
            const newRows = rows.filter((row) => {
                let matches = true;

                const properties = ['file_name', 'file_type', 'file_size', 'labels', 'created_date'];
                let containsQuery = false;

                properties.forEach((property) => {
                    if (row[property]?.toString().toLowerCase().includes(newString.toString().toLowerCase())) {
                        containsQuery = true;
                    }
                });

                if (!containsQuery) {
                    matches = false;
                }
                return matches;
            });
            setRows(newRows);
        } else {
            setOriginalRows(rows);
        }
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleClick = () => {
        const id = randomId();
        let columns = {
            id,
            isNew: true
        };
        projectsState.documents?.columns?.split('|')?.map((data, index) => {
            if (data !== 'id' && data !== '_id' && data !== 'isNew') {
                columns[data] = '';
            }
        });
        setDocumentRows((oldRows) => [columns, ...oldRows]);

        setRowModesModel((oldModel) => ({
            ...oldModel,
            [id]: { mode: GridRowModes.Edit, fieldToFocus: 'id' }
        }));
    };

    const handleSubmit = () => {
        // Khi submit
        console.log('Current connections:', edges);
        console.log('Current nodes:', nodes);
        // Bạn có thể xử lý edges để lấy thông tin chi tiết hoặc gửi đi đâu đó
    };
    // const EditToolbar = (props) => {
    //     const { documentRows, setDocumentRows, setRowModesModel } = props;
    //     // let rows = documentRows
    //     // rows['isNew'] = true
    //     // console.log(rows)
    //     const handleClick = () => {
    //         console.log(documentRows)
    //         setDocumentRows((oldRows) => [
    //             ...oldRows,
    //             documentRows,
    //         ]);

    //         setRowModesModel((oldModel) => ({
    //             ...oldModel,
    //             [id]: { mode: GridRowModes.Edit, fieldToFocus: 'id' },
    //         }));
    //     };

    //     return (
    //         <GridToolbarContainer>
    //             <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
    //                 Add record
    //             </Button>
    //         </GridToolbarContainer>
    //     );
    // }

    let documentColumns = [
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<SaveIcon />}
                            label="Save"
                            sx={{
                                color: 'primary.main'
                            }}
                            onClick={() => {
                                handleSaveClick(id);
                            }}
                        />,
                        <GridActionsCellItem
                            icon={<CancelIcon />}
                            label="Cancel"
                            className="textPrimary"
                            onClick={() => {
                                handleCancelClick(id);
                            }}
                            color="inherit"
                        />
                    ];
                }

                return [
                    <GridActionsCellItem
                        icon={<EditIcon />}
                        label="Edit"
                        className="textPrimary"
                        onClick={() => {
                            handleEditClick(id);
                        }}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<DeleteIcon />}
                        label="Delete"
                        onClick={() => {
                            handleDeleteClick(id);
                        }}
                        color="inherit"
                    />
                ];
            }
        }
    ];

    let arr = projectsState.documents?.columns?.split('|');

    arr?.map((data, index) => {
        if (data !== 'id' && data !== '_id') {
            documentColumns.push({
                field: data,
                headerName: data,
                width: 180,
                editable: true
            });
        } else {
            documentColumns.push({
                field: data,
                headerName: data,
                width: 180
            });
        }
    });

    return (
        <>
            {isSetting === false && (
                <>
                    {!hideTableUploadFile && (
                        <>
                            <MainCard
                                title={projectSubname ? `DAG trong dự án ${projectSubname}` : 'Danh sách DAG'}
                                content={false}
                                sx={{ overflow: 'visible' }}
                            >
                                <div>
                                    <CardContent>
                                        <Grid container spacing={1.5} sx={{ justifyContent: 'flex-end', alignItems: 'center', mb: 2 }}>
                                            <Grid item>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => {
                                                        setOpenAddTask(true);
                                                        setDagUpdate(false);
                                                        setDagName('');
                                                        setNodes([{ id: '1', type: 'start', data: { label: 'Start' }, position: { x: 100, y: 0 } }]);
                                                        setEdges([]);
                                                        setCronExp('0 0 * * *');
                                                        setSchedulePreset('0 0 * * *');
                                                        dispatch(fetchProjectAirflowDags(folderName.replace('/', '')));
                                                    }}
                                                    startIcon={<StorageIcon />}
                                                >
                                                    Tạo DAG mới
                                                </Button>
                                            </Grid>
                                            <Grid item>
                                                <Button
                                                    variant="outlined"
                                                    href={AIRFLOW_URL || 'http://localhost:31400'}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    Mở Airflow UI
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12} sm="auto" sx={{ ml: 'auto', display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                                <Select
                                                    size="small"
                                                    value={timeRange}
                                                    onChange={handleTimeRangeChange}
                                                    sx={{ minWidth: 140 }}
                                                >
                                                    {options.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <Select
                                                    size="small"
                                                    value={sort}
                                                    onChange={(e) => {
                                                        setSort(e.target.value);
                                                        handleRequestSort(null, 'created_date');
                                                    }}
                                                    sx={{ minWidth: 160 }}
                                                >
                                                    {sortOptions.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <TextField
                                                    size="small"
                                                    sx={{ width: { xs: '100%', sm: 200 } }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SearchIcon fontSize="small" />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    onChange={handleSearch}
                                                    placeholder="Tìm kiếm DAG..."
                                                    value={search}
                                                />
                                            </Grid>
                                        </Grid>
                                        {(!dagsName || dagsName.length === 0) ? (
                                            <Box
                                                sx={{
                                                    py: 6,
                                                    px: 2,
                                                    textAlign: 'center',
                                                    borderRadius: 2,
                                                    bgcolor: 'grey.50',
                                                    border: '1px dashed',
                                                    borderColor: 'grey.300'
                                                }}
                                            >
                                                <StorageIcon sx={{ fontSize: 48, color: 'grey.400', mb: 1 }} />
                                                <Typography variant="body1" color="text.secondary" gutterBottom>
                                                    Chưa có DAG nào. Tạo DAG mới để thiết lập luồng và lịch chạy.
                                                </Typography>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    sx={{ mt: 2 }}
                                                    onClick={() => {
                                                        setOpenAddTask(true);
                                                        setDagUpdate(false);
                                                        setDagName('');
                                                        setNodes([{ id: '1', type: 'start', data: { label: 'Start' }, position: { x: 100, y: 0 } }]);
                                                        setEdges([]);
                                                        setCronExp('0 0 * * *');
                                                        setSchedulePreset('0 0 * * *');
                                                        dispatch(fetchProjectAirflowDags(folderName.replace('/', '')));
                                                    }}
                                                >
                                                    Tạo DAG mới
                                                </Button>
                                            </Box>
                                        ) : (
                                        <Grid container spacing={2} sx={{ mt: 1 }}>
                                            {dagsName?.map((data, index) => (
                                                <Grid item xs={12} sm={6} md={4} key={index}>
                                                    <Paper
                                                        component="button"
                                                        type="button"
                                                        onClick={() => {
                                                            setOpenAddTask(true);
                                                            setDagName(data.dag_name);
                                                            const interval = data.schedule_interval || '0 0 * * *';
                                                            setCronExp(interval);
                                                            const matched = CRON_PRESETS.find((p) => p.value !== 'custom' && p.value === interval);
                                                            setSchedulePreset(matched ? matched.value : 'custom');
                                                            setDagUpdate(true);
                                                            dispatch(
                                                                getProjectAirflowDagsNodes(folderName.replace('/', ''), data.dag_name)
                                                            );
                                                            dispatch(
                                                                getProjectAirflowDagsEdges(folderName.replace('/', ''), data.dag_name)
                                                            );
                                                        }}
                                                        sx={{
                                                            p: 2,
                                                            textAlign: 'left',
                                                            width: '100%',
                                                            cursor: 'pointer',
                                                            borderRadius: 2,
                                                            border: '1px solid',
                                                            borderColor: 'divider',
                                                            transition: 'all 0.2s',
                                                            '&:hover': {
                                                                borderColor: 'primary.light',
                                                                boxShadow: 2,
                                                                bgcolor: 'action.hover'
                                                            }
                                                        }}
                                                    >
                                                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                                                            <Box
                                                                sx={{
                                                                    width: 40,
                                                                    height: 40,
                                                                    borderRadius: 1.5,
                                                                    bgcolor: 'primary.light',
                                                                    color: 'primary.dark',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center'
                                                                }}
                                                            >
                                                                <StorageIcon sx={{ fontSize: '1.25rem' }} />
                                                            </Box>
                                                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                                                <Typography variant="subtitle1" fontWeight={600} color="text.primary" noWrap>
                                                                    {data.dag_name}
                                                                </Typography>
                                                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                                                                    {data.num_of_task} task · Nhấn để chỉnh sửa
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Paper>
                                                </Grid>
                                            ))}
                                        </Grid>
                                        )}
                                    </CardContent>
                                </div>
                            </MainCard>
                            <Dialog
                                open={isOpenAddTask}
                                fullScreen
                                onClose={() => {
                                    setOpenAddTask(false);
                                    setDagNameExists(false);
                                    setDagName('');
                                }}
                                aria-labelledby="dag-form-dialog-title"
                                PaperProps={{
                                    sx: { borderRadius: 0, bgcolor: 'background.paper' }
                                }}
                            >
                                {isOpenAddTask && (
                                    <>
                                        <DialogTitle
                                            id="dag-form-dialog-title"
                                            sx={{
                                                py: 1.5,
                                                px: 2,
                                                borderBottom: '1px solid',
                                                borderColor: 'divider',
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 2,
                                                flexWrap: 'wrap'
                                            }}
                                        >
                                            <Typography variant="h6" component="span" fontWeight={600}>
                                                {isDagUpdate ? dagName : 'Tạo DAG mới'}
                                            </Typography>
                                            {!isDagUpdate && (
                                                <TextField
                                                    size="small"
                                                    placeholder="Tên DAG (vd: etl_daily)"
                                                    value={dagName}
                                                    error={isDagNameExists}
                                                    onChange={(e) => {
                                                        setDagName(e.target.value);
                                                        setDagNameExists(
                                                            (dagsName || []).some(
                                                                (d) =>
                                                                    d.dag_name?.trim().toLowerCase() ===
                                                                    removeAccents(e.target.value.trim().toLowerCase())
                                                            )
                                                        );
                                                    }}
                                                    sx={{ width: 220 }}
                                                />
                                            )}
                                            <Box sx={{ flex: 1 }} />
                                            <Button variant="outlined" color="inherit" size="small" onClick={() => setOpenAddTask(false)}>
                                                Đóng
                                            </Button>
                                            {isDagUpdate && (
                                                <Button variant="outlined" color="error" size="small" onClick={() => setOpenDeleteModal(true)}>
                                                    Xóa DAG
                                                </Button>
                                            )}
                                            <Button
                                                size="small"
                                                variant="contained"
                                                disabled={dagName === '' || isDagNameExists}
                                                onClick={() => {
                                                    dispatch(
                                                        insertProjectAirflowDags(
                                                            folderName.replace('/', ''),
                                                            dagName,
                                                            { nodes, edges },
                                                            cronExp
                                                        )
                                                    );
                                                }}
                                            >
                                                {isDagUpdate ? 'Cập nhật' : 'Lưu DAG'}
                                            </Button>
                                        </DialogTitle>
                                        <DialogContent sx={{ p: 0, overflow: 'hidden', display: 'flex', flexDirection: 'row', flex: 1, minHeight: 0 }}>
                                            <Box
                                                sx={{
                                                    width: 300,
                                                    flexShrink: 0,
                                                    borderRight: '1px solid',
                                                    borderColor: 'divider',
                                                    bgcolor: 'grey.50',
                                                    overflowY: 'auto'
                                                }}
                                            >
                                                <Paper variant="outlined" sx={{ m: 2, p: 2, borderRadius: 2, bgcolor: 'background.paper' }}>
                                                        <Typography variant="subtitle2" color="text.secondary" gutterBottom sx={{ fontWeight: 600 }}>
                                                            Cấu hình
                                                        </Typography>
                                                        <Divider sx={{ mb: 2 }} />
                                                        <Stack spacing={2}>
                                                            {isDagUpdate && (
                                                                <Typography variant="body2" color="text.secondary">
                                                                    DAG: <strong>{dagName}</strong>
                                                                </Typography>
                                                            )}
                                                            <Box>
                                                                <Typography variant="subtitle2" color="text.secondary" gutterBottom sx={{ fontWeight: 600 }}>
                                                                    Lịch chạy
                                                                </Typography>
                                                                <FormControl fullWidth size="small" sx={{ mb: 1.5 }}>
                                                                    <InputLabel id="schedule-preset-label">Loại lịch</InputLabel>
                                                                    <Select
                                                                        labelId="schedule-preset-label"
                                                                        value={schedulePreset}
                                                                        label="Loại lịch"
                                                                        onChange={(e) => {
                                                                            const v = e.target.value;
                                                                            setSchedulePreset(v);
                                                                            if (v !== 'custom') setCronExp(v);
                                                                        }}
                                                                    >
                                                                        {CRON_PRESETS.map((p) => (
                                                                            <MenuItem key={p.value} value={p.value}>
                                                                                {p.label}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                </FormControl>
                                                                {schedulePreset === 'custom' ? (
                                                                    <Box
                                                                        className="dag-cron-editor"
                                                                        id="dag-cron-container"
                                                                        sx={{
                                                                            mt: 1,
                                                                            p: 2,
                                                                            borderRadius: 1.5,
                                                                            bgcolor: 'grey.50',
                                                                            border: '1px solid',
                                                                            borderColor: cronError ? 'error.light' : 'divider',
                                                                            width: '100%',
                                                                            minWidth: 0,
                                                                            overflow: 'auto',
                                                                            maxHeight: 320
                                                                        }}
                                                                    >
                                                                        <Cron
                                                                            value={cronExp}
                                                                            setValue={setCronExp}
                                                                            onError={setCronError}
                                                                            shortcuts={true}
                                                                            humanizeLabels={true}
                                                                            getPopupContainer={() =>
                                                                                document.getElementById('dag-cron-container') || document.body
                                                                            }
                                                                        />
                                                                        {cronError && (
                                                                            <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
                                                                                {cronError}
                                                                            </Typography>
                                                                        )}
                                                                    </Box>
                                                                ) : (
                                                                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                                                        Biểu thức cron: <strong>{schedulePreset}</strong>
                                                                    </Typography>
                                                                )}
                                                            </Box>
                                                            {!isDagUpdate && (
                                                                <>
                                                                    <Divider />
                                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                                                                        <Typography variant="subtitle2" color="text.secondary" gutterBottom sx={{ fontWeight: 600, mb: 0 }}>
                                                                            Chọn task (file .py trong airflow/dags)
                                                                        </Typography>
                                                                        <Button
                                                                            size="small"
                                                                            variant="outlined"
                                                                            onClick={() => dispatch(fetchProjectAirflowDags(folderName.replace('/', '')))}
                                                                        >
                                                                            Làm mới
                                                                        </Button>
                                                                    </Box>
                                                                    <FormControl fullWidth size="small" sx={{ mt: 1 }}>
                                                                        <InputLabel id="dag-tasks-label">Task</InputLabel>
                                                                        <Select
                                                                            labelId="dag-tasks-label"
                                                                            multiple
                                                                            value={taskName}
                                                                            onChange={handleChange}
                                                                            input={<OutlinedInput label="Task" />}
                                                                            renderValue={(selected) =>
                                                                                selected.length ? selected.join(', ') : 'Chưa chọn'
                                                                            }
                                                                            MenuProps={MenuProps}
                                                                        >
                                                                            {task.map((name) => {
                                                                                if (name.includes('.py') && !name.includes('config.py')) {
                                                                                    return (
                                                                                        <MenuItem key={name} value={name}>
                                                                                            <Checkbox checked={taskName.includes(name)} />
                                                                                            <ListItemText primary={name} />
                                                                                        </MenuItem>
                                                                                    );
                                                                                }
                                                                                return null;
                                                                            })}
                                                                        </Select>
                                                                    </FormControl>
                                                                    {task.length === 0 && (
                                                                        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                                                                            Chưa có file .py trong thư mục airflow/dags. Copy script vào rồi bấm Làm mới.
                                                                        </Typography>
                                                                    )}
                                                                </>
                                                            )}
                                                        </Stack>
                                                    </Paper>
                                                </Box>
                                                <Box
                                                    sx={{
                                                        flex: 1,
                                                        minWidth: 0,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        overflow: 'hidden'
                                                    }}
                                                >
                                                    <Paper variant="outlined" sx={{ flex: 1, m: 2, display: 'flex', flexDirection: 'column', overflow: 'hidden', borderRadius: 2 }}>
                                                        <Typography variant="subtitle2" color="text.secondary" sx={{ px: 2, py: 1.5, fontWeight: 600 }}>
                                                            Sơ đồ luồng
                                                        </Typography>
                                                        <Divider />
                                                        <Box
                                                            sx={{
                                                                flex: 1,
                                                                minHeight: 360,
                                                                '& .react-flow': { bgcolor: 'grey.50' },
                                                                '& .react-flow__background': { bgcolor: '#fafafa' }
                                                            }}
                                                            className="dag-canvas-wrapper"
                                                        >
                                                            <ReactFlow
                                                                nodes={nodes}
                                                                edges={edges}
                                                                onNodesChange={onNodesChange}
                                                                onEdgesChange={onEdgesChange}
                                                                onConnect={onConnect}
                                                                onInit={(instance) => { flowRef.current = instance; }}
                                                                nodeTypes={nodeTypes}
                                                                defaultEdgeOptions={{ type: 'smoothstep', style: { stroke: '#94a3b8', strokeWidth: 2 } }}
                                                                fitView
                                                                fitViewOptions={{ padding: 0.2 }}
                                                            >
                                                                <MiniMap nodeColor={(n) => (n.type === 'start' ? '#43a047' : n.type === 'end' ? '#757575' : '#1976d2')} />
                                                                <Controls showInteractive={false} />
                                                                <Background variant="dots" gap={16} size={1} color="#cbd5e1" />
                                                            </ReactFlow>
                                                        </Box>
                                                    </Paper>
                                                </Box>
                                        </DialogContent>
                                    </>
                                )}
                            </Dialog>
                            <DeleteAirflow
                                open={openDeleteModal}
                                dagName={dagName}
                                closeModal={() => setOpenDeleteModal(false)}
                                handleConfirm={handleDelete}
                            />
                        </>
                    )}
                </>
            )}

            {logOpen && <LogComponent onBack={handleBack} />}
            {metaDataOpen && <MetaDataComponent onBack={handleBack} folerName={folderName} fileName={fileName} />}
        </>
    );
};

export default TableAirflow;
